/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Plans_Lifetime_DescriptionInputs */

const en_pricing_plans_lifetime_description = /** @type {(inputs: Pricing_Plans_Lifetime_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Premium features with one-time payment`)
};

const es_pricing_plans_lifetime_description = /** @type {(inputs: Pricing_Plans_Lifetime_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Funciones premium con pago unico`)
};

/**
* | output |
* | --- |
* | "Premium features with one-time payment" |
*
* @param {Pricing_Plans_Lifetime_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const pricing_plans_lifetime_description = /** @type {((inputs?: Pricing_Plans_Lifetime_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Plans_Lifetime_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pricing_plans_lifetime_description(inputs)
	return es_pricing_plans_lifetime_description(inputs)
});